import React, { Component, Fragment } from 'react';
import Cropper from 'react-cropper';
import '../../node_modules/cropperjs/dist/cropper.css';
import { AuthConsumer } from '../context/AuthContext';
import FETCH from '../Fetch';
import { Link } from 'react-router-dom';
import { toast } from './Notifier';
import NetworkError from './NetworkError';

// profile loader
import ProfileLoader from '../loaderComponents/ProfilleLoader';

class Profile extends Component {
  state = { showModal: false, loading: true };

  componentDidMount() {
    FETCH.getProfile().then(response => {
      if (response.status === 'error') {
        this.setState({ error: true });
        return;
      }

      this.setState({ user: response.data, loading: false });
    });
  }

  showModal = () => {
    this.setState({ showModal: true });
  };

  render() {
    const { loading } = this.state;

    return this.state.error ? (
      <NetworkError message="Your profile could not be fetched at the moment, please try again later" />
    ) : (
        <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
          <h1>My Profile</h1>
          {/* card for registered courses display  */}
          <div className="row no-gutters">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body profile p-0">
                  <div className="row m-0">
                    {loading ? (
                      <ProfileLoader />
                    ) : (
                        <Fragment>
                          <ProfileDetails userData={this.state.user} />
                          <ProfileOperations userData={this.state.user.bioData} />
                          <ChangePassword userData={this.state.user} />
                          <UploadPassport />
                        </Fragment>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      );
  }
}

class ProfileOperations extends Component {
  state = {
    formDetails: {
      phone: this.props.userData.phone,
      contact_address: this.props.userData.contact_address,
      next_of_kin: this.props.userData.next_of_kin,
      gender: this.props.userData.gender,
      next_of_kin_address: this.props.userData.next_of_kin_address,
      next_of_kin_phone: this.props.userData.next_of_kin_phone
    },
    requestPending: false
  };

  handleChange = e => {
    let { formDetails } = this.state;
    formDetails[e.target.name] = e.target.value;

    this.setState({ formDetails });
  };

  updateProfile = updateData => {
    this.setState({ requestPending: true });

    const data = Object.assign({}, this.state.formDetails);
    const filteredData = {};
    for (let prop in data) {
      prop = prop.trim();
      if (data[prop] !== '') {
        filteredData[prop] = data[prop];
      }
    }

    if (!Object.keys(filteredData).length) {
      this.setState({ requestPending: false });
      toast('Form fields cannot be empty', { status: 'error' });
      return;
    }

    FETCH.UpdateProfile(filteredData)
      .then(response => {
        this.setState({ requestPending: false });

        if (response.status === 'success') {
          updateData({
            gender: this.state.formDetails.gender,
            ...(this.state.formDetails.alternative_email && {
              personal_email: this.state.formDetails.alternative_email
            }),
            ...(this.state.formDetails.user_login && {
              user_login: this.state.formDetails.user_login
            })
          });
          toast(response.message, { status: response.status });
        } else {
          toast(this.interpreteErrorMessage(response.message), {
            status: response.status
          });
        }
      })
      .catch(error => {
        this.setState({ requestPending: false });
        toast(
          'Could not update profile, something went wrong. Please try again later',
          {
            status: 'error'
          }
        );
      });
  };

  interpreteErrorMessage = msgObj => {
    let field, message;
    for (let key in msgObj) {
      field = key;
      message = msgObj[key];
    }
    return `${field}: ${message}`;
  };

  render() {
    const { userData } = this.props;

    return (
      <AuthConsumer>
        {({ updateData }) => (
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 p-0">
            <div className="profile-detail-container">
              <h3 className="mt-4">Edit Personal Details</h3>
              <button
                className="btn btn-gray w-100 text-dark"
                data-toggle="modal"
                data-target="#modalCart"
                onClick={this.props.showModal}
              >
                Change Password
              </button>
              <hr className="separator" />
              <div className="profile-form-container mt-4">
                <form
                  className="edit-profile"
                  onSubmit={_ => this.updateProfile(updateData)}
                  autoComplete="off"
                >
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="phone"
                      className="form-control"
                      id="phone"
                      name="phone"
                      aria-describedby="Enter your phone number"
                      placeholder="Entre Phone No: "
                      defaultValue={userData.phone}
                      value={this.state.phone}
                      onChange={this.handleChange}
                      autoComplete="off"
                    />
                  </div>
                  {Number(userData.has_institution_email) ? (
                    <div className="form-group">
                      <label htmlFor="email">Email address</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="alternative_email"
                        placeholder="Email"
                        defaultValue={userData.personal_email}
                        onChange={this.handleChange}
                        autoComplete="off"
                      />
                    </div>
                  ) : (
                      <div className="form-group">
                        <label htmlFor="email">Email address</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="user_login"
                          placeholder="Email"
                          defaultValue={userData.user_login}
                          onChange={this.handleChange}
                          autoComplete="off"
                        />
                      </div>
                    )}
                  <div className="form-group">
                    <label htmlFor="contact">Contact Address</label>
                    <input
                      type="address"
                      className="form-control"
                      id="contactaddress"
                      name="contact_address"
                      placeholder="Contact address"
                      defaultValue={userData.contact_address}
                      value={this.state.address}
                      onChange={this.handleChange}
                      autoComplete="off"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="gender">Gender</label>
                    <select
                      className="custom-select"
                      id="genderSelect"
                      name="gender"
                      defaultValue={userData.gender}
                      onChange={this.handleChange}
                    >
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="nok">Next of Kin</label>
                    <input
                      type="text"
                      className="form-control"
                      id="nok"
                      name="next_of_kin"
                      placeholder="Next of kin"
                      defaultValue={userData.next_of_kin}
                      value={this.state.next_of_kin}
                      onChange={this.handleChange}
                      autoComplete="off"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="nok_p">Next of Kin's Phone</label>
                    <input
                      type="phone"
                      className="form-control"
                      name="next_of_kin_phone"
                      placeholder="Next of kin phone"
                      defaultValue={userData.next_of_kin_phone}
                      value={this.state.next_of_kin_phone}
                      onChange={this.handleChange}
                      autoComplete="off"
                      id="nok_p"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="nok_a">Next of Kin's Address</label>
                    <input
                      type="address"
                      className="form-control"
                      name="next_of_kin_address"
                      placeholder="Next of kin"
                      defaultValue={userData.next_of_kin_address}
                      value={this.state.next_of_kin_address}
                      onChange={this.handleChange}
                      autoComplete="off"
                      id="nok_a"
                    />
                  </div>
                </form>
              </div>
            </div>
            {/* button */}
            <div className="footer">
              {/* subtitute active class for disabled to either make button active or inactive */}
              <button
                style={{
                  backgroundColor: this.state.requestPending
                    ? '#02750e'
                    : '#00d715'
                }}
                disabled={this.state.requestPending}
                className="position-relative btn w-100 btn-primary-big btn-border-radius-login active"
                onClick={_ => this.updateProfile(updateData)}
              >
                {this.state.requestPending ? (
                  <i className="fas fa-circle-notch fa-spin" />
                ) : (
                    'Save Details'
                  )}
              </button>
            </div>
          </div>
        )}
      </AuthConsumer>
    );
  }
}

class ProfileDetails extends Component {
  state = {
    avatarShown: true
  }
  componentDidMount() {
    this.avatar.onload = () => {
      this.setState({ avatarShown: true })
    }
    this.avatar.onerror = () => {
      this.setState({ avatarShown: false })
    }
  }
  render() {
    let { userData: { bioData: { passport, has_passport } } } = this.props;
    console.log(this.props)
    return (
      <AuthConsumer>
        {({ user }) => (
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 p-0 border-right">
            <div className="profile-details text-center">
              <img
                ref={el => (this.avatar = el)}
                src={user.passport}
                className="image-rounded-circle"
                alt="student profile avatar"
              />
              {!passport && has_passport === 0 ? (
                <p>
                  <a
                    className="btn btn-gray text-dark"
                    data-toggle="modal"
                    data-target="#passportUploadModal"
                    onClick={this.props.showModal}
                  >
                    Upload passport
                  </a>
                </p>
              ) : (
                  ''
                )}
              <div className="name">{`${user.lastname.toUpperCase()}, ${
                user.firstname
                }`}</div>
              <div className="matric-number">
                {Number(user.has_matric_number)
                  ? 'Matric. No.:'
                  : 'Application No:'}{' '}
                <span>{user.matric_number}</span>
              </div>
            </div>
            <div className="profile-detail-container">
              <h3>Academic Details</h3>
              <div className="row detail-container m-0">
                <div className="col-lg-6 text">Level</div>
                <div className="col-lg-6 text text-dark bold text-lg-right">
                  {`${user.level}00 Level`}
                </div>
              </div>
              <hr className="separator" />
              <div className="row detail-container m-0">
                <div className="col-lg-6 text">Programme</div>
                <div className="col-lg-6 text text-dark bold text-lg-right overflow-ellipsis">
                  {`${user.programme}`}
                </div>
              </div>
              <hr className="separator" />
              <div className="row detail-container m-0">
                <div className="col-lg-6 text">Faculty</div>
                <div className="col-lg-6 text text-dark bold text-lg-right overflow-ellipsis">
                  {user.faculty}
                </div>
              </div>
              <hr className="separator" />
              <div className="row detail-container m-0">
                <div className="col-lg-6 text">Email</div>
                <div className="col-lg-6 text text-dark bold text-lg-right overflow-ellipsis">
                  {!user.user_login ? user.personal_email : user.user_login}
                </div>
              </div>
            </div>
          </div>
        )}
      </AuthConsumer>
    );
  }
}

class UploadPassport extends Component {
  constructor() {
    super();
    this.state = {
      passport: '',
      imagePreview: '',
      errorMessage: [],
      loading: false
    };

    this.uploadPassport = this.uploadPassport.bind(this);
  }

  setPassport(e) {
    if (!e.target.files[0]) return;
    this.setState({
      imageName: e.target.files[0].name,
      lastModifiedDate: e.target.files[0].lastModifiedDate,
      imageFormat: e.target.files[0].type
    });

    let that = this;
    let reader = new FileReader();
    reader.onload = function () {
      let image = new Image();
      let errorMessage = [];
      image.onload = () => {
        that.setState({ croppedWidth: image.width });
      };

      image.src = reader.result;
      that.imageRef = image;
      that.setState({
        imagePreview: reader.result
      });
    };
    reader.readAsDataURL(e.target.files[0]);
  }

  uploadPassport(updateData) {
    if (this.state.croppedWidth && this.state.croppedWidth > 200) {
      return this.setState({
        errorMessage: [
          'Image dimension must not be more than 200px by 200px, drag your mouse over the image to crop.'
        ]
      });
    }

    this.setState({ loading: true, errorMessage: [] });
    let formData = new FormData();

    formData.append('file', this.state.passport, this.state.passport.name);

    FETCH.PassportUpload(formData)
      .then(res => {
        this.closeButton.click();
        toast(res.message, { status: res.status });
        updateData({
          passport: res.passport
        });
      })
      .catch(error => {
        console.log(error);
      });
  }

  onCropChange = croppedWidth => {
    this.setState({ croppedWidth: croppedWidth });
  };

  zoomCrop = val => {
    let cropper = this.cropper;
    if (val === 0) {
      cropper.zoom(-0.1);
    } else {
      cropper.zoom(0.1);
    }
  };

  onCropComplete = () => {
    let crop = this.cropper.getData(),
      pixelCrop = this.cropper.getData();
    this.makeClientCrop(crop, pixelCrop);
  };

  async makeClientCrop(crop, pixelCrop) {
    this.setState({ croppedWidth: parseInt(pixelCrop.width) });
    if (crop.width && this.imageRef) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        pixelCrop,
        this.state.imageName
      );

      this.setState({ passport: croppedImageUrl });
    } else console.log('no crop selected');
  }

  base64ToFile(b64Data) {
    if (!b64Data) return;
    let ImageURL = b64Data;
    // Split the base64 string in data and contentType
    var block = ImageURL.split(';');
    // Get the content type of the image
    var contentType = block[0].split(':')[1]; // In this case "image/gif"
    // get the real base64 content of the file
    var realData = block[1].split(',')[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."

    contentType = contentType || this.state.imageFormat;
    let sliceSize = sliceSize || 512;

    let byteCharacters = window.atob(realData);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      let byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    let file = new File(byteArrays, this.state.imageName, {
      type: contentType
    });

    // let blob = new Blob(byteArrays, { type: contentType });
    return file;
  }

  getCroppedImg(image, pixelCrop, fileName) {
    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    const base64Image = canvas.toDataURL(this.state.imageFormat);

    return new Promise((resolve, reject) => {
      resolve(this.base64ToFile(base64Image));
    });
  }

  render() {
    const {
      imagePreview,
      imageError,
      imageName,
      errorMessage,
      loading
    } = this.state;

    return (
      <AuthConsumer>
        {({ updateData }) => (
          <div
            className="modal fade"
            id="passportUploadModal"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="Passport upload modal"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                {/*Header*/}
                <div className="modal-header">
                  <h5 className="modal-title modal-text" id="myModalLabel">
                    Upload Passport
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    ref={el => (this.closeButton = el)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                {/*Body*/}
                <div className="modal-body profile-detail-container">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="col-md-12 pl-r imagePreview text-center">
                            {/* {imagePreview?<img src={imagePreview} width="150px" height="150px" />:<img src="images/sample.png" width="207px" height="200px" />} */}
                            {imagePreview ? (
                              <Fragment>
                                <Cropper
                                  src={imagePreview}
                                  ref={el => (this.cropper = el)}
                                  style={{ height: 200, width: '100%' }}
                                  aspectRatio={1}
                                  crop={this.onCropComplete}
                                // guides={false}
                                />
                              </Fragment>
                            ) : (
                                <p />
                              )}
                            <p>
                              {this.state.croppedWidth
                                ? `Width: ${this.state.croppedWidth}, Height: ${
                                this.state.croppedWidth
                                }`
                                : ''}
                            </p>
                            <div className="file-loading">
                              <input
                                id="passport"
                                type="file"
                                accept="image/*"
                                onChange={this.setPassport.bind(this)}
                              />
                              {/* <span className="browse">
                              <i className="fa fa-upload" /> Browse
                            </span> 
                            <p>{imageName ? imageName : 'Select Image...'}</p>*/}
                            </div>
                          </div>
                          <p className="fileupload-info-text text-center pt-2">
                            Image dimension should not be more than 200x200 and
                            size must not be more than 150kb
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*Footer*/}
                <div className="footer">
                  {/* subtitute active class for disabled to either make button active or inactive */}
                  {/* button */}
                  <button
                    className="position-relative btn w-100 btn-primary-big btn-border-radius-login active"
                    onClick={() => this.uploadPassport(updateData)}
                    style={{
                      backgroundColor: this.state.loading
                        ? '#02750e'
                        : '#00d715'
                    }}
                  >
                    {this.state.loading ? <i className="fas fa-circle-notch fa-spin" /> : 'Upload passport'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Modal: modalCart */}
      </AuthConsumer>
    );
  }
}

class ChangePassword extends Component {
  constructor() {
    super();
    this.handlePasswordReset = this.handlePasswordReset.bind(this);
  }
  state = {
    currentpassword: '',
    newpassword: '',
    confirmpassword: ''
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handlePasswordReset = e => {
    e.preventDefault();

    const { newpassword, confirmpassword } = this.state;
    if (newpassword.length < 6 || confirmpassword.length < 6) {
      return this.setState(
        {
          error: 'password must contain at least 6 characters'
        },
        () =>
          toast('password must contain at least 6 characters', {
            status: 'error'
          })
      );
    }

    if (newpassword !== confirmpassword) {
      return toast('confirm password not correct', {
        status: 'error'
      });
    }

    const data = {
      user_pass: confirmpassword,
      current_password: this.state.currentpassword
    };

    FETCH.ChangePassword(data)
      .then(response => {
        if (response.status === 'success') {
          this.setState({
            currentpassword: '',
            newpassword: '',
            confirmpassword: '',
            error: '',
            success: response.message
          });
          toast(response.message, { status: 'success' });
          this.closeButton.click();
        } else {
          toast(response.message, { status: 'error' });
        }
      })
      .catch(error => {
        toast('Could not change password check network connectivity', {
          status: 'error'
        });
      });
  };

  render() {
    return (
      <Fragment>
        {/* Modal: modalCart */}
        <div
          className="modal fade"
          id="modalCart"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="Password reset modal"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              {/*Header*/}
              <div className="modal-header">
                <h5 className="modal-title modal-text" id="myModalLabel">
                  Change Password
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  ref={el => (this.closeButton = el)}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              {/*Body*/}
              <div className="modal-body profile-detail-container">
                <form
                  className="edit-profile"
                  onSubmit={this.handlePasswordReset}
                  autoComplete="off"
                >
                  <div className="form-group row">
                    <label htmlFor="currentpassword">
                      Enter Current Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="currentpassword"
                      aria-describedby="passwordhelp"
                      placeholder="Current Password"
                      name="currentpassword"
                      value={this.state.currentpassword}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="form-group row">
                    <label htmlFor="newpassword">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="newpassword"
                      placeholder="New Password"
                      name="newpassword"
                      value={this.state.newpassword}
                      onChange={this.handleChange}
                      min-length={6}
                      required
                    />
                  </div>
                  <div className="form-group row">
                    <label htmlFor="confirmpassword">Confirm password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmpassword"
                      placeholder="Confirm password"
                      name="confirmpassword"
                      value={this.state.confirmpassword}
                      onChange={this.handleChange}
                      required
                      min-length={6}
                    />
                  </div>
                </form>
              </div>
              {/*Footer*/}
              <div>
                {/* button */}
                <div className="footer">
                  {/* subtitute active class for disabled to either make button active or inactive */}
                  <button
                    className="position-relative btn w-100 btn-primary-big btn-border-radius-login active"
                    onClick={this.handlePasswordReset}
                  >
                    Change Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Profile;
